import { createBrowserHistory } from 'history';

// Create the history object
const browserHistory = createBrowserHistory();

// Get current URL parameters
const queryParams = getUrlParams();

export const history = {
	queryParams,
	subs: {},
	subscribe( uid, fn ) {
		this.subs[ uid ] = fn;
	},
	unsubscribe( uid ) {
		delete this.subs[ uid ];
	},
	changeParams( params ) {
		this.queryParams = params;
		Object.keys( this.subs ).forEach( key => this.subs[ key ]( params ) );
	},
};

export const historyComponentMixin = {
	data: () => ({
		history: {
			queryParams: history.queryParams,
			history: browserHistory,
			push: browserHistory.push,
			replace: browserHistory.replace,
			setQueryParam,
		},
	}),
	beforeCreate() {
		history.subscribe( this._uid, params => {
			this.updateQueryParams( params );
		});
	},
	beforeDestroy() {
		history.unsubscribe( this._uid );
	},
	methods: {
		updateQueryParams( params ) {
			this.$set( this.history, 'queryParams', params );
		},
	},
};

history.install = function () {
	// Listen for changes to the current location.
	browserHistory.listen( () => {
		const queryParams = getUrlParams();
		history.changeParams( queryParams );
	});
};

function setQueryParam( key = '', value = '', method = 'replace' ) {
	const params = getUrlParams();
	params[ key ] = value;
	const search = createQueryParameterString( params );
	browserHistory[ method ]({
		pathname: browserHistory.location.pathname,
		hash: browserHistory.location.hash,
		search,
	});
}

function getUrlParams() {
	const search = browserHistory.location.search || '';
	return parseUrlParams( decodeURIComponent( search ) );
}

function parseUrlParams( s = '' ) {
	// Trim the input
	const search = s.trim();

	// Return empty object if empty
	if ( search === '' || search === '?' ) {
		return {};
	}

	// we'll store the parameters here
	let obj = {};
  
	// split our query string into its component parts
	let arr = search
		.replace( /^\?/, '' )
		.split( '&' )
		.map( pair => pair.split( '=' ) );
  
	arr.forEach( ([ key, value ]) => {
		// in case params look like: list[]=thing1&list[]=thing2
		let paramNum;
		let paramName = key.replace( /\[\d*\]/, function( v ) {
			paramNum = v.slice( 1, -1 );
			return '';
		});

		// set parameter value (use 'true' if empty)
		let paramValue = typeof( value ) === 'undefined' ? true : value;

		// (optional) keep case consistent
		paramName = paramName.toLowerCase();
		paramValue = paramValue.toLowerCase();

		// if parameter name already exists
		if ( obj[paramName]) {
			// convert value to array (if still string)
			if ( typeof obj[paramName] === 'string' ) {
				obj[paramName] = [ obj[paramName] ];
			}
			// if no array index number specified...
			if ( typeof paramNum === 'undefined' ) {
				// put the value on the end of the array
				obj[paramName].push( paramValue );
			} else {
				// if array index number specified...
				// put the value at that index number
				obj[paramName][paramNum] = paramValue;
			}
		} else {
			// if param name doesn't exist yet, set it
			obj[paramName] = paramValue;
		}
	});
  
	return obj;
}

export function createQueryParameterString( queryParams ) {
	if ( queryParams.length === 0 ) {
		return '';
	}

	const params = Object
		.keys( queryParams )
		.filter( key => queryParams[ key ] !== '' && queryParams[ key ] !== null )
		.map( key => {
			let value = queryParams[ key ];

			if ( value instanceof Array ) {
				return value
					.map( value => `${key}[]=${value}` )
					.join( '&' );
			} else {
				return `${key}=${value}`;
			}
		})
		.join( '&' );
	
	return `?${params}`;
}



// WEBPACK FOOTER //
// ./assets/_js/plugins/history.js